<script>
import validationRules from '../../../mixins/validationRules';

export default {
  name: 'Period',
  mixins: [
    validationRules,
  ],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      modifiableData: undefined,
    };
  },
  computed: {
    daysBetween() {
      if (!this.modifiableData.from ||
        this.modifiableData.from.length !== 8 ||
        !this.modifiableData.to ||
        this.modifiableData.to.length !== 8
      ) {
        this.$emit('valid', false);
        return undefined;
      }

      const from = this.$moment(this.modifiableData.from, 'DD/MM/YY');
      const to = this.$moment(this.modifiableData.to, 'DD/MM/YY');

      if (!from.isValid() || !to.isValid() || !from.isBefore(to)) {
        this.$emit('valid', false);
        return undefined;
      }
      this.$emit('valid', true);
      return to.diff(from, 'days') + 1;
    },
  },
  created() {
    if (this.data && this.data.from && this.data.to) {
      this.modifiableData = {
        from: this.data.from,
        to: this.data.to,
      };
    } else {
      this.modifiableData = {
        from: undefined,
        to: undefined,
      };
    }
    this.$emit('update:data', this.modifiableData);
  },
};
</script>

<template>
  <v-layout row>
    <v-flex grow>
      <v-text-field
        v-model="modifiableData.from"
        :rules="[validationRules.required, validationRules.date('DD-MM-YY')]"
        label="Date From (DD-MM-YY)"
        mask="##-##-##"
        class="text-field-height-fix"
        return-masked-value
        clearable
        box
        @input="$emit('update:data', modifiableData)"
      />
    </v-flex>
    <v-flex shrink mx-4 mt-3 trigger-rules-settings__period-days text-xs-center>
      <span v-if="daysBetween" class="grey--text font-italic caption">
        {{ daysBetween }} {{ daysBetween > 1 ? 'Days' : 'Day' }}
      </span>
      <span v-else class="error--text font-italic caption">
        Invalid setup
      </span>
    </v-flex>
    <v-flex grow>
      <v-text-field
        v-model="modifiableData.to"
        :rules="[validationRules.required, validationRules.date('DD-MM-YY')]"
        label="Date To (DD-MM-YY)"
        mask="##-##-##"
        class="text-field-height-fix"
        return-masked-value
        clearable
        box
        @input="$emit('update:data', modifiableData)"
      />
    </v-flex>
  </v-layout>
</template>

<style lang="scss">
.trigger-rules-settings {
  &__period-days {
    width: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Triggers/TriggerRuleSettingTypes/Period.vue